package uz.ferro.erp.feature.product.utils

import uz.ferro.erp.feature.country.model.Country

fun Country.flagUrl(): String {
//    return "icons/flags/circle/${key.orEmpty().lowercase()}.svg"
    return "https://raw.githubusercontent.com/lipis/flag-icons/refs/heads/main/flags/1x1/${key.orEmpty().lowercase()}.svg"
}